<template>
  <div class="phoneBottom"></div>
</template>

<script>
export default {
  name: 'phoneBottom',
}
</script>

<style lang="scss" scoped>
.phoneBottom {
  width: 100%;
  background-color: #fff;
  min-height: 145px;
  cursor: pointer;
  padding-top: 30px;
  box-sizing: border-box;
}
</style>
